export default "__VITE_ASSET__8e5b8dee__"